module.exports = __webpack_public_path__ + "img/munic-san-miguel-soi.36edfc68.png";